import React from "react";
import { Link } from "react-router-dom";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Form,
  Container,
  Row,
  Col,
} from "reactstrap";


function SectionContactUs() {
  return (
    <>
      <div className="cd-section" id="contact-us">
        <div className="contactus-2" style={{
          paddingTop: "0", height: "100%",
          backgroundImage:
            "url(" + require("assets/img/doha.jpg") + ")",
        }}>
          <Container style={{paddingTop: "10%", paddingBottom: "10%"}}>
            <Row>
              <div style={{ paddingLeft: "25%" }}>
              </div>
              <Col md="6">
                <Card className="card-contact card-raised" style={{ backgroundColor: "#333333", color: "#ffffff" }}>
                  <CardHeader className="header-raised header-primary text-center" style={{ backgroundColor: "#333333", color: "#ffffff", marginBottom: "0" }}>
                    <CardTitle tag="h4" style={{ backgroundColor: "#333333", color: "#ffffff" }}>Find Us</CardTitle>
                  </CardHeader>
                  <Form id="contact-form2" method="post" role="form">
                    <CardBody style={{ paddingTop: "0" }}>
                      <Row>
                        <Col md="6">
                          <div className="info info-horizontal">
                            <div className="icon icon-info">
                              <i className="nc-icon nc-badge" />
                            </div>
                            <div className="description">
                              <h5 className="info-title" style={{ color: "#ffffff" }}>Give us a call</h5>
                              <p style={{ color: "#ffffff" }}>
                                +974 4020 6636 <br />
                                Sun - Thu <br />
                                09:00 - 17:00
                            </p>
                            </div>
                          </div>
                        </Col>
                        <Col md="6">
                          <div className="info info-horizontal">
                            <div className="icon icon-danger">
                              <i className="nc-icon nc-pin-3" />
                            </div>
                            <div className="description">
                              <h5 className="info-title" style={{ color: "#ffffff" }}>
                                Visit our office
                            </h5>
                              <p style={{ color: "#ffffff" }}>
                                Doha, <br />
                                Qatar
                            </p>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <div style={{ paddingLeft: "40%" }}>
                          <Button
                            className="btn-round"
                            color="neutral"
                            type="button"
                            to="/contact-us"
                            tag={Link}
                            outline
                          >
                            Let's meet ?
                          </Button>
                        </div>
                      </Row>
                    </CardBody>
                  </Form>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </>
  );
}

export default SectionContactUs;